import { CalendarSlot } from "@/models/Calendar";
import { ProductRegistrationType, CouponLimitationType, CouponDiscountType, CouponWhoFinances, CouponType } from "@/models/Enums";
import { PriceType } from "./Interfaces";
export class ProductListItem {
  id = 0;
  name = "";
  color = "";
  registrationType = ProductRegistrationType.RegistrationIsRequired;
  extraInfo = "";
  orderBlockMinutes = 0;
  withCoupon = false;
  productSlots = Array<CalendarSlot>();
  productImages = Array<ProductImage>();
  productPrices = Array<ProductPrice>();
}

export class ProductImage {
  pathMedium = "";
  isMainImage = false;
}

export class ProductPrice {
  channelId = 0;
  id = 0;
  priceTypeId = 0;
  title = "";
  productPriceLines = Array<ProductPriceLine>();
  businessClientId = 0;
  businessClientTypeId = 0;
}

export class ProductPriceLine {
  id = 0;
  productCustomerTypeId = 0;
  amount = 0;
  currencyId = 0;
  quantity: null | number;
  customerTypeName = "";

  constructor() {
    this.quantity = 0;
  }
}

// export class SlotAvailability {
//   productId = 0;
//   dates = Array<AvailabilityDate>();
// }

// export class AvailabilityDate {
//   date = new Date();
//   isAvailable = false;
//   priceLists = Array<AvailabilityPriceList>();
// }

// export class AvailabilityPriceList {
//   productPriceId = 0;
//   title = "";
//   channelId = 0;
//   channelName = "";
//   priceLines = Array<PriceLine>();
// }

// export class PriceLine {
//   customerTypeId = 0;
//   customerTypePrice = 0;
//   customerTypeName = "";
//   currencyId = 0;
// }

// export class QuantityItem {
//   customerTypeId = 0;
//   quantity = 0;
// }
export interface PreloadPricesAndSlotsResponse {
  slots: GetProductSlotsResponse;
  prices: GetProductPricesResponse;
}

export interface GetProductSlotsResponse {
  slots: Slot[];
}

export interface Slot {
  id: number;
  startTime: string;
  endTime: string;
  productId: number;
  quantity: number;
  isVirtual: boolean;
  duration: string;
  slotFakeId: string;
}

export interface GetProductPricesResponse {
  prices: Price[];
}

export interface Price {
  id: number;
  productId: number;
  priceTypeId: number;
  fromDate: string;
  toDate: string;
  title: string;
  remarks: string;
  officialPrice: number;
  currencyId: number;
  pricePerPerson: boolean;
  channelId: number;
  channelName: string;
  priceLines: PriceLine[];
  productPriceId: number;
  businessClientId: number | null;
  businessClientTypeId: number | null;
}

export class PriceLine {
  id = 0;
  name = "";
  priceForOne = 0;
  quantity = 0;
  discount = 0;
  qtyToUse = 0;
  coupon: Coupon | null = null;
  couponId: number | null = null;
  orderProductCustomerId: number | null = null;
  barcode: string | null = null;
  get customerQuantity(): number {
    return this.quantity * this.qtyToUse;
  }
}

export interface SelectedProduct {
  date: string;
  productId: number;
  slotId: number;
  slotStartTime: string;
  slotEndTime: string;
  quantity: number;
  slotDuration: string;
  slotFakeId: number;
}

export interface Currencies {
  id: number;
  name: string;
  culture: string;
  symbol: string;
}

export interface CurrencyRate {
  currencyId: number;
  rate: number;
}

export interface IdName {
  id: number;
  name: string;
}

export interface Coupon {
  id: number;
  couponName: string;
  couponCode: string;
  currencyId: number | null;
  currencySymbol: string;
  clubIds: number[];
  productIds: number[];
  discountPercent: number;
  discountAmount: number;
  ticketFixedUnitPrice: number;
  leftLimitationTotal: number;
  ticketLimitation: number | null;
  limitationType: CouponLimitationType;
  customerTypes: number[];
  validDateFrom: string;
  validDateTo: string;
  priceTypeIds: number[];
  couponType: CouponType;
  discountType: CouponDiscountType;
  whoFinances: CouponWhoFinances;
  businessClientTypeId: number;
}
